import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConditionsOfApplicability, ConfigStatut } from '@lib/models/generated/graphql';
import { OuiDialogService } from 'omnium-ui/dialog';
import { Subject, takeUntil } from 'rxjs';
import {
  CommentaireDeVersionColumn,
  ConfigVersionColumn,
  DeleteDraftColumn,
  DLCColumn,
  DownloadTemplateColumn,
  FicheConfigColumn,
  IsMajeurColumn,
  MaJColumn,
  SetActiveColumn,
  StatutColumn,
  TemplateNameColumn,
  VersionColumn,
} from 'src/app/components/admin-page/admin-fiche/fiche-config-table/fiche-config-columns';
import { AddConseilConfigVersionDialogComponent } from 'src/app/components/admin-page/admin-fiche/fiche-details/add-conseil-config-version-dialog/add-conseil-config-version-dialog.component';
import { AdminConfig, AdminConfigList, AdminConfigService } from 'src/app/services/admin-config.service';
type HeaderConfig = { coa: ConditionsOfApplicability | undefined; libelle: string; lastUpdate: string | null };
@Component({
  selector: 'app-fiche-details',
  templateUrl: './fiche-details.component.html',
  styleUrls: ['./fiche-details.component.scss'],
})
export class FicheDetailsComponent {
  columnSelection: FicheConfigColumn[] = [
    new StatutColumn(),
    new VersionColumn(),
    new MaJColumn(),
    new DLCColumn(),
    new TemplateNameColumn(),
    // new TemplateColumn(),
    new IsMajeurColumn(),
    new ConfigVersionColumn(),
    new SetActiveColumn(),
    new CommentaireDeVersionColumn(),
    new DownloadTemplateColumn(),
    new DeleteDraftColumn(),
  ];
  displayedColumns: string[] = this.columnSelection.map(column => column.header);
  requestResult: { data: { items: AdminConfig[]; totalCount: number }; loading: boolean } | undefined;

  headerCoA: HeaderConfig | undefined;
  selectedCoAId: string | undefined;
  firstLoad = true;
  currentActiveVersion = 0;

  private ngUnsubscribe = new Subject<void>();
  constructor(
    private route: ActivatedRoute,
    private adminConfigService: AdminConfigService,
    private dialogService: OuiDialogService,
    private datePipe: DatePipe,
    private router: Router
  ) {}

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  ngOnInit(): void {
    //merge params and configs observers
    this.selectedCoAId = this.route.snapshot.paramMap.get('coaId') ?? undefined;

    this.adminConfigService.adminConfigsSubject.pipe(takeUntil(this.ngUnsubscribe)).subscribe(configs => {
      if (!configs.loading && configs.configs.length === 0 && this.firstLoad) {
        this.fetchAllConfigs();
        this.firstLoad = false;
      }
      this.updateConfigs(configs);
    });
  }

  fetchAllConfigs() {
    this.requestResult = { data: { items: [], totalCount: 0 }, loading: true };
    this.adminConfigService.fetchAllConfigs();
  }

  updateConfigs(configs: AdminConfigList | undefined) {
    if (configs && configs?.configs.length > 0 && this.selectedCoAId) {
      const configWithSelectedCoAId = configs.configs
        .filter(config => {
          return config?.conseilConfig?.conditionsOfApplicability?.id === this.selectedCoAId;
        })
        .sort((a, b) => {
          // sort by version DESC
          return (b.conseilConfig?.version ?? 0) - (a.conseilConfig?.version ?? 0);
        });

      const activeVersion = configWithSelectedCoAId.find(config => config.statut === ConfigStatut.Active);
      let lastUpdate: string | null = null;
      if (activeVersion) {
        lastUpdate = this.datePipe.transform(activeVersion.conseilConfig?.lastChangeDate, 'dd/MM/yyyy');
        this.currentActiveVersion = activeVersion.conseilConfig?.version ?? 0;
      }
      if (configWithSelectedCoAId.length > 0) {
        this.requestResult = {
          data: { items: configWithSelectedCoAId, totalCount: configWithSelectedCoAId.length ?? 0 },
          loading: configs.loading,
        };
      }

      this.headerCoA = {
        coa: configWithSelectedCoAId[0]?.conseilConfig?.conditionsOfApplicability || undefined,
        libelle: configWithSelectedCoAId[0]?.conseilConfig?.libelle || '',
        lastUpdate: !!lastUpdate
          ? lastUpdate
          : this.datePipe.transform(configWithSelectedCoAId[0]?.conseilConfig?.lastChangeDate, 'dd/MM/yyyy'),
      };
    }
  }

  onConfigClick(config: AdminConfig) {
    //nothing to do
  }

  onAddVersion() {
    const typeRef = this.dialogService.openDialog(
      AddConseilConfigVersionDialogComponent,
      { coaId: this.selectedCoAId, activeVersion: this.currentActiveVersion },
      'auto',
      '648px'
    );
    typeRef.afterClosed().subscribe(result => {
      if (result) {
        this.fetchAllConfigs();
      }
    });
  }
  onBack() {
    this.router.navigate(['/admin/fiches']);
  }
}
